import React, {Component} from "react";
import logo from "./img/logo-is-white.png";
import config from "../../../data/SiteConfig";
import Scroll from 'react-scroll'; // Imports all Mixins
import styles from "./Header.module.scss";


let Link = Scroll.Link;

let ContactLink = React.createClass({
    render:function() {

        if ( typeof window !== 'undefined' && window.location.pathname !== '/') {
                return (
                    <a id="contact" href="/contact" title="Nous Contacter"><i className={`icon-envelope `}/></a>
                );

        } else {
                return (
                    <Link activeClass="active" to="fh5co-contact" href="#" spy={true} smooth={true} offset={50} duration={1000} title="Contacter Integral Service"><i className={`icon-envelope`}/></Link>
                );
        }
    }
})

class Header extends Component {
    constructor(props) {
        super(props)
        this.state =  {animateClass: ''};
    }
    componentDidMount(node) {
        if (typeof window !== 'undefined') {
            window.addEventListener('scroll', this.handleScroll.bind(this));
        }
    }

    componentWillUnmount() {
        if (typeof window !== 'undefined') {
            window.removeEventListener('scroll',
                this.handleScroll.bind(this));
        }
    }

    handleScroll(event) {
        let scrollPosition = window.document.body.scrollTop;

        if(scrollPosition){
            this.setState({animateClass : styles.scrolling});

        }else{
            this.setState({animateClass : ''});

        }

    }
    render() {
        let scrollClass = this.state.animateClass;
        return (
            <section className={styles.fh5coheader}>
                <div className="container-fluid m-0 p-0">
                    <nav role="navigation">
                        <h1 className={`d-flex justify-content-center ${styles.fh5cologo}`}>
                            <a href="/" title="Revenir à l'accueil d'integral system" className={`align-self-center text-center ${styles.logoContainer}`}>
                                <img src={logo} className={styles.toplogo} alt="Logo Integral Service, studio Web"/>
                            </a>
                        </h1>
                        <div>
                            <span className={` ${scrollClass} ${styles.hoverbtn}`}>
                                    <span className={styles.hiddenname}>Contactez&nbsp;Nous&nbsp;!</span>
                                    <ContactLink/>
                            </span>
                        </div>
                    </nav>
                </div>
            </section>
        );
    }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/Header.jsx